module.exports = __webpack_public_path__ + "img/gas02.763d36ed.gif";